import { Navigate, Route, Routes, useParams } from "react-router-dom";
import { AppShell } from "@/components/layout/AppShell";
import { RequireAuth } from "@/auth/RequireAuth";
import { HomePage } from "@/pages/HomePage";
import { RegistryPage } from "@/pages/RegistryPage";
import { StandardsPage } from "@/pages/StandardsPage";
import { ToolsPage } from "@/pages/ToolsPage";
import { DeliveryBriefsPage } from "@/pages/DeliveryBriefsPage";
import { MapPage } from "@/pages/MapPage";
import { ReviewPage } from "@/pages/ReviewPage";

/** The shell is the one thing wrapped in RequireAuth, so every page route below it is
 * behind login without each page guarding itself. */
const ProtectedShell = RequireAuth(AppShell);

/** The route table: one route per page in the nav, all nested in the authenticated shell;
 * any unknown path goes back to Home. */
export function App() {
  return (
    <Routes>
      <Route element={<ProtectedShell />}>
        <Route index element={<HomePage />} />
        <Route path="registry" element={<RegistryPage />} />
        <Route path="registry/:capabilityId" element={<RegistryPage />} />
        <Route path="overview" element={<Navigate to="/registry" replace />} />
        <Route path="standards" element={<StandardsPage />} />
        <Route path="standards/:standardId" element={<StandardsPage />} />
        <Route path="tools" element={<ToolsPage />} />
        <Route path="tools/:toolId" element={<ToolsPage />} />
        <Route path="practices/:practiceId" element={<StandardsPage />} />
        <Route path="practices" element={<Navigate to="/standards" replace />} />
        <Route path="briefs" element={<DeliveryBriefsPage />} />
        <Route path="briefs/:mapId" element={<DeliveryBriefsPage />} />
        {/* The page's former name. */}
        <Route path="guardrails" element={<Navigate to="/briefs" replace />} />
        <Route path="guardrails/:mapId" element={<GuardrailsRedirect />} />
        <Route path="map" element={<MapPage />} />
        <Route path="review" element={<ReviewPage />} />
        <Route path="review/:mapId" element={<ReviewPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

/** An old `/guardrails/<map id>` link, sent to the same map's delivery brief. */
function GuardrailsRedirect() {
  const { mapId } = useParams();
  return <Navigate to={`/briefs/${encodeURIComponent(mapId ?? "")}`} replace />;
}
